<template>
  <div>
    <div v-if="display" class="weui-mask" role="button" aria-label="关闭弹窗"></div>
    <div v-if="display" class="weui-dialog" role="dialog" aria-labelledby="title3" aria-modal="true">
      <div class="weui-dialog__hd">
        <strong id="title3" class="weui-dialog__title">{{ titleText || "温馨提示" }}</strong>
      </div>
      <div class="weui-dialog__bd">{{ msgText }}</div>
      <div class="weui-dialog__ft">
        <a role="button" href="javascript:void 0;" class="weui-dialog__btn weui-dialog__btn_primary" @click="confirm">{{
          confirmText || "确认"
        }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs } from "@vue/composition-api"
export default {
  props: {
    // 标题
    titleText: {
      type: String,
      default: ""
    },

    // 提示信息
    msgText: {
      type: String,
      default: ""
    },

    // 点击确认的回调
    onConfirm: {
      type: Function
    },

    // 确认按钮
    confirmText: {
      type: String,
      default: ""
    }
  },

  setup(props) {
    const state = reactive({
      display: false
    })

    const show = () => {
      state.display = true
    }

    const hide = () => {
      state.display = false
    }

    const confirm = () => {
      if (props.onConfirm) {
        props.onConfirm()
      } else {
        hide()
      }
    }

    return {
      ...toRefs(state),
      show,
      hide,
      confirm
    }
  }
}
</script>
